import { ESearchResultsActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const closeSearchResultsSidebar = actionGenerator<ESearchResultsActionType.SidebarClosed>(
  ESearchResultsActionType.SidebarClosed,
);
